import { useEffect, useState, useContext, useMemo } from "react";
import  DemandsTableModal                       from "./DemandsTableModal";
import { InputFilePageContext }                 from '../../contexts/InputFilePageContext';
import { useUser }                              from '../../contexts/UserContext';
import api                                      from "../../services/api";
import { findPermission }                       from '../../utils/UserPermissionUtils.js';

function DemandsTableModalContainer() {
    
    const { userData } = useUser()

    const {

        handleUpdateDemandTable,
        handleDemandsModalClose,
        isDemandsModalOpen, 
        
        selectedDemandPostId, 

        demandDates, 
        isLoading,
        loading

    } = useContext(InputFilePageContext)

    const [__modalTitle, __setModalTitle]   = useState(null)
    const [__approvals, __setApprovals]     = useState({})
    const [__comments, __setComments]       = useState({})

    const [__allApprovedBtnStatus, __setAllApprovedBtnStatus] = useState(false);

    const [__demandPostColumns, __setDemandPostColumns] = useState([])
    const [__demandPostLines,   __setDemandPostLines]   = useState([])

    const [ _hasPermission,  _setHasPermission ] = useState(false)

    const [ _textFilter,     _setTextFilter     ] = useState('')
    const [ _approvalFilter, _setApprovalFilter ] = useState('todos') // 'todos' | 'aprovado' | 'reprovado'
   
    const __filteredDemandPostLines = useMemo(() => {

        if (!Array.isArray(__demandPostLines)) return __demandPostLines

        let result = __demandPostLines

        // filtro de texto, múltiplos termos separados por ';' (E)
        const terms = _textFilter
            .split(';')
            .map((term) => term.trim().toLowerCase())
            .filter(Boolean)

        if (terms.length > 0) {

            result = result.filter((line) => {

                const searchableText = [
                    line.ownerTerminal?.name,
                    line.ownerProduct?.name,
                ].filter(Boolean).join(' ').toLowerCase()

                return terms.every((term) => searchableText.includes(term))

            })

        }

        // filtro de aprovação
        if (_approvalFilter !== 'todos') {

            result = result.filter((line) => {

                if (_approvalFilter === 'aprovado')  return line.isApproved
                if (_approvalFilter === 'reprovado') return !line.isApproved

                return true

            })

        }

        return result

    }, [__demandPostLines, _textFilter, _approvalFilter])

    const handleClick = async () => {
        
        try {
            
            const response = await api.get(
                `/getDemandPostExcelById/${selectedDemandPostId}`,
                { responseType: 'blob' }
            );

            // 👉 Lê o header
            const contentDisposition = response.headers['content-disposition'];

            let fileName = 'arquivo.xlsx'; // fallback

            if (contentDisposition) {
                const match = contentDisposition.match(/filename="(.+)"/);
                if (match?.[1]) {
                    fileName = match[1];
                }
            }

            // Cria o blob e o link
            const url = window.URL.createObjectURL(
                new Blob([response.data], {
                    type: response.headers['content-type'],
                })
            )

            const link = document.createElement('a');
            link.href  = url;
            link.setAttribute('download', fileName);

            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("❌ Erro ao baixar Excel:", error);
        }

    }



    const __handleApprovalChange = (id) => {

        __setDemandPostLines(prev =>
            prev.map(item =>
                item.id === id
                    ? { ...item, isApproved: !item.isApproved }
                    : item
            )
        );
        
    }

    const __handleCommentChange = (id, value) => {

        __setDemandPostLines(prev =>
            prev.map(item =>
                item.id === id
                    ? { ...item, description: value }
                    : item
            )
        );

    }

    function __toggleAllApprovals() {
              
        __setAllApprovedBtnStatus(() => {
            
            const newValue = !__allApprovedBtnStatus;
    
            __setDemandPostLines(prev =>
                prev.map(item => ({
                    ...item,
                    isApproved: newValue
                }))
            );
    
            return newValue;
        });
    }

    const fetchDemandContent = async () => {

        try{ 
            
            const response = await api.get(`/getDemandsByPostId/${selectedDemandPostId}`)
 
            const { demandPostLines, demandPostColumns } = response.data

            __setDemandPostColumns(demandPostColumns)
            __setDemandPostLines(demandPostLines)

            isLoading(false)

        } catch(error) {
            console.log("Error in DemandPostId search", error)
        }
    }

    const handleSubmitApprovals = async () => {
        
        try{

            await api.put(`/updateDemandPostLines/${selectedDemandPostId}`, { 
                demandPostLines: __demandPostLines,
                userId: userData.id 
            })

            handleDemandsModalClose()
            handleUpdateDemandTable()

        } catch(error){
            console.log("Error in handleSubmitApprovals", error)
        } 

    }

    useEffect(() => {

        if (isDemandsModalOpen && selectedDemandPostId) {
            fetchDemandContent()
            isLoading(true)
        }

    }, [isDemandsModalOpen, selectedDemandPostId])

    useEffect(() => {

        if (!demandDates) return;
    
        const initialApprovals = {};
	    const initialComments  = {};

        demandDates.forEach(date =>

            date.demands.forEach(demand => {
                
                const assessmentId = demand?.demandApprovment?.id;
                
                if (assessmentId) {
                    initialApprovals[assessmentId] = demand.demandApprovment?.isApproved    || false;
				    initialComments[assessmentId]  = demand.demandApprovment?.comment       || '';
                }

            })
        );
        
        __setApprovals(initialApprovals);
		__setComments(initialComments);

    }, [demandDates]);

    useEffect(()=>{ 



        const hasPermission = findPermission(userData, "Aprovar Demandas")
        _setHasPermission(hasPermission)

    },[userData])
    

    return(

        <DemandsTableModal
            
            isOpen={isDemandsModalOpen}
            onClose={handleDemandsModalClose}
            
            loading={loading}

            hasPermission={_hasPermission}        

            handleApprovalChange={__handleApprovalChange}
            handleCommentChange={__handleCommentChange}
            handleSubmitApprovals={handleSubmitApprovals}

            allApprovedBtnStatus={__allApprovedBtnStatus}
            toggleAllApprovals={__toggleAllApprovals}

            modalTitle={__modalTitle}
            demandPostColumns={__demandPostColumns}
            demandPostLines={__filteredDemandPostLines}

            textFilter={_textFilter}
            setTextFilter={_setTextFilter}
            approvalFilter={_approvalFilter}
            setApprovalFilter={_setApprovalFilter}

            handleClick={handleClick}
            selectedDemandPostId={selectedDemandPostId}

        />
    )
}

export default DemandsTableModalContainer;